export const CAPITAL_AMOUNT_MIN = 50000000;
export const CAPITAL_AMOUNT_MAX = 100000000000;

export const HEDGING_MIN_CAPITAL = 500000000;

export const MIN_CHART_POINTS = 7;

export const DEFAULT_PROFILE = {
  strategyModel: "orbit",
  stockUniverse: "pool_50",
  activateGold: false,
  activateFixedIncome: false,
  activateCrypto: false,
  marginEnabled: false,
  hedgingEnabled: false,
  capitalAmount: 0,
  investingExperience: 0,
};

export const MARGIN_SAFE_THRESHOLD = 1.3;
export const MARGIN_CAUTION_THRESHOLD = 1.5;

export const RATIO_MARKER_PADDING = 0.13;
export const RATIO_MARKER_MIN = MARGIN_SAFE_THRESHOLD - RATIO_MARKER_PADDING;
export const RATIO_MARKER_MAX = MARGIN_CAUTION_THRESHOLD + RATIO_MARKER_PADDING;

export const MARGIN_RATIO_STATE_MAP = {
  safe: { label: "An toàn", color: "#34D399" },
  caution: { label: "Cần chú ý", color: "#EC8000" },
  critical: { label: "Margin call", color: "#FF6B6B" },
};

export const HEDGE_MARGIN_STATUS = {
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  MARGIN_CALL: "MARGIN_CALL",
};

export const PORTFOLIO_TYPE = {
  BACKTEST: "backtest",
  PAPER: "paper",
  LIVE: "live",
};

export const NEBULA_STATUS = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  RUNNING: "RUNNING",
  REINIT: "REINIT",
  SUSPENDED: "SUSPENDED",
  INIT: "INIT",
  ERROR: "ERROR",
  UNSUPPORTED: "UNSUPPORTED",
};

export const INIT_STATUSES = [NEBULA_STATUS.INIT, NEBULA_STATUS.REINIT];

export const isInitStatus = (status) => INIT_STATUSES.includes(status);

export const NEBULA_STATUS_MAP = {
  ACTIVE: {
    label: "Đang hoạt động",
    color: "#34D399",
    bg: "#34D3991A",
    text: "#34D399",
  },
  SUSPENDED: {
    label: "Tạm dừng",
    color: "#C5C5C7",
    bg: "#F5F5F5",
    text: "#A0A0A5",
  },
  RUNNING: {
    label: "Đang xử lý",
    color: "#F59E0B",
    bg: "#F59E0B1A",
    text: "#F59E0B",
  },
  REINIT: {
    label: "Đang tạm dừng",
    color: "#F59E0B",
    bg: "#F59E0B1A",
    text: "#F59E0B",
  },
  SUSPENDED: {
    label: "Đang tạm dừng",
    color: "#F59E0B",
    bg: "#F59E0B1A",
    text: "#F59E0B",
  },
  INIT: {
    label: "Chưa hoạt động",
    color: "#636369",
    bg: "#3C3C430D",
    text: "#636369",
  },
  UNSUPPORTED: {
    label: "Không hỗ trợ",
    color: "#9CA3AF",
    bg: "#9CA3AF1A",
    text: "#9CA3AF",
  },
};

export const ALLOCATION_STATUS = {
  ACTIVE: "ACTIVE",
  STOPPED: "STOPPED",
  INACTIVE: "INACTIVE",
};

export const ASSET_CLASS = {
  stocks: "stocks",
  gold: "gold",
  fixed_income: "fixed_income",
  crypto: "crypto",
  margin: "vn30_futures",
};

export const TICKER_TO_PROFILE_FLAG = {
  gold: "activateGold",
  crypto: "activateCrypto",
  fixed_income: "activateFixedIncome",
  vn30_futures: "hedgingEnabled",
  margin: "marginEnabled",
};

export const ASSET_CLASS_OPTIONS = [
  { id: "composite", label: "Tất cả" },
  { id: "stocks", label: "Cổ phiếu" },
  { id: "gold", label: "Vàng" },
  { id: "fixed_income", label: "Tiền gửi & Trái phiếu" },
  { id: "crypto", label: "Crypto" },
];

export const DETAIL_ASSET_CLASS_OPTIONS = ASSET_CLASS_OPTIONS.filter(
  (option) => option.id !== "composite",
);

export const MAP_TYPE_TO_NAME = {
  stocks: "Cổ phiếu",
  gold: "Vàng",
  fixed_income: "Tiền gửi & Trái phiếu",
  crypto: "Crypto",
  vn30_futures: "Hedging",
  margin: "Nợ vay margin",
};

export const MAP_TYPE_TO_META_UNIT = {
  stocks: "mã",
  gold: "loại",
  fixed_income: "loại",
  crypto: "coin",
  vn30_futures: "hợp đồng",
  margin: "",
};

export const ASSET_CLASS_DOT_COLOR = {
  stock: "bg-[#B9A2FB]",
  stocks: "bg-[#B9A2FB]",
  gold: "bg-[#FCCC50]",
  crypto: "bg-[#F09933]",
  margin: "bg-[#FF8989]",
  vn30_futures: "bg-[#5DDCAD]",
  fixed_income: "bg-[#3389F0]",
};

export const MAP_TICKER_TO_NAME = {
  "GC=F": "Vàng",
  BTCUSDT: "Bitcoin",
  "ECONOMICS:VNINBR": "Lãi suất liên ngân hàng",
};

export const DECISION_TYPE = {
  MARGIN_CALL: "MARGIN_CALL",
  MARGIN_TOGGLED: "MARGIN_TOGGLED",
  MARGIN_INTEREST: "MARGIN_INTEREST",
  HEDGE_PLANNED: "HEDGE_PLANNED",
  HEDGE_EXECUTED: "HEDGE_EXECUTED",
  HEDGE_MARGIN_CALL_CLOSE: "HEDGE_MARGIN_CALL_CLOSE",
  DAILY_DIGEST: "DAILY_DIGEST",
  DIVERGENCE_FLAGGED: "DIVERGENCE_FLAGGED",
};

export const PLAN_TYPES = [
  "REBALANCE_PLANNED",
  "CROSS_ASSET_REALLOCATION_PLANNED",
  "HEDGE_PLANNED",
  "FIXED_INCOME_PLANNED",
];

export const DECISION_TYPE_LABEL = {
  PORTFOLIO_INITIALIZED: "Khởi tạo danh mục",
  PORTFOLIO_REINITIALIZED: "Khởi tạo lại danh mục",
  ALREADY_INITIALIZED: "Danh mục đã khởi tạo",
  MISSING_PROFILE: "Thiếu hồ sơ đầu tư",
  ASSET_CLASS_ACTIVATION: "Nhóm tài sản",
  HEDGING_TOGGLED: "Phòng vệ VN30",
  MARGIN_TOGGLED: "Margin",
  MODEL_REFRESHED: "Cập nhật mô hình",
  DEPOSIT: "Nạp tiền",
  WITHDRAWAL: "Rút tiền",
  WITHDRAWAL_REJECTED: "Từ chối rút tiền",
  DIVIDEND_RECEIVED: "Nhận cổ tức",
  WATCH_DAILY: "Rà soát thị trường",
  WATCH_NO_SIGNAL: "Không có tín hiệu",
  REBALANCE_PLANNED: "Lên lịch tái cân bằng",
  REBALANCE_EXECUTED: "Tái cân bằng",
  REBALANCE_PARTIAL: "Khớp một phần",
  REBALANCE_SUPERSEDED: "Thay thế tín hiệu",
  CROSS_ASSET_REALLOCATION_PLANNED: "Lên lịch phân bổ liên tài sản",
  CROSS_ASSET_REALLOCATION_EXECUTED: "Phân bổ liên tài sản",
  FIXED_INCOME_PLANNED: "Lên lịch thu nhập cố định",
  FIXED_INCOME_EXECUTED: "Thu nhập cố định",
  HEDGE_PLANNED: "Lên lịch phòng vệ",
  HEDGE_EXECUTED: "Thực hiện phòng vệ",
  HEDGE_MARGIN_CALL_CLOSE: "Margin call - đóng hedge cưỡng bức",
  DIVERGENCE_FLAGGED: "Lệch Live và Paper",
  CAPITAL_SYNCED: "Đồng bộ vốn",
  CAPITAL_MISMATCH: "Lệch vốn",
  CAPITAL_CHANGE_PENDING_LIQUIDATION: "Chờ thanh lý đổi vốn",
  CAPITAL_CHANGE_COMPLETED: "Hoàn tất đổi vốn",
  CAPITAL_CHANGE_PARTIAL_COMPLETED: "Đổi vốn hoàn tất một phần",
  CAPITAL_CHANGE_FAILED: "Đổi vốn thất bại",
  CAPITAL_CHANGE_CANCELLED: "Hủy đổi vốn",
  CAPITAL_CHANGE_REJECTED: "Từ chối đổi vốn",
  MARGIN_INTEREST: "Lãi vay Margin",
  MARGIN_CALL: "Margin Call",
  DIVERGENCE_FLAGGED_OUT_OF_UNIVERSE: "Mã ngoài Universe",
  DIVERGENCE_FLAGGED_CASH_DELTA: "Lệch số dư tiền",
  STOCK_DIVIDEND_APPLIED: "Cổ tức cổ phiếu",
  RIGHTS_ISSUE_CASH: "Quyền mua cổ phiếu",
  ORDER_CANCELLED_BY_CA: "Hủy lệnh do sự kiện",
  DAILY_DIGEST: "Tổng kết ngày",
};

export const HEDGE_MARGIN_TAB_OPTIONS = [
  { id: "hedging", label: "Hedging" },
  { id: "margin", label: "Margin" },
];

export const HEDGE_REASON_MAP = {
  cadence: "Cân bằng lại định kỳ",
  expiry_roll: "Đáo hạn hợp đồng",
  rebalance: "Cân bằng lại",
  margin_call: "Margin call",
};

export const HEDGE_ORDER_STATUS_MAP = {
  PENDING: "Đang chờ",
  pending: "Đang chờ",
  EXECUTED: "Đã thực hiện",
  filled: "Đã khớp",
  CANCELLED: "Đã hủy",
  expired_by_new_signal: "Hết hạn - tín hiệu mới",
};

export const TIER = {
  free: "FREE",
  basic: "BASIC",
  pro: "PRO",
  max: "MAX",
};

export const TIER_RANK = {
  [TIER.free]: 0,
  [TIER.basic]: 1,
  [TIER.pro]: 2,
  [TIER.max]: 3,
};

export const TIER_NAV_RANGE = {
  [TIER.free]: { min: CAPITAL_AMOUNT_MIN, max: 500000000 },
  [TIER.basic]: { min: CAPITAL_AMOUNT_MIN, max: 500000000 },
  [TIER.pro]: { min: 500000000, max: 2000000000 },
  [TIER.max]: { min: 2000000000, max: CAPITAL_AMOUNT_MAX },
};

export const FEATURE_MIN_TIER = {
  "strategyModel:horizon": TIER.pro,
  "stockUniverse:pool_100": TIER.pro,
  activateFixedIncome: TIER.max,
  activateGold: TIER.pro,
  activateCrypto: TIER.max,
  marginEnabled: TIER.pro,
  hedgingEnabled: TIER.max,
};

export const LOCKED_ASSET_META = {
  gold: {
    feature: "activateGold",
    message: "Mở khóa Vàng để bù trừ rủi ro khi cổ phiếu điều chỉnh",
  },
  fixed_income: {
    feature: "activateFixedIncome",
    message: "Mở khóa Tiền gửi & trái phiếu để ổn định danh mục",
  },
  crypto: {
    feature: "activateCrypto",
    message: "Mở khóa Crypto để mở rộng danh mục sang tài sản số",
  },
};

export const TIER_STYLE_MAP = {
  [TIER.max]: {
    text: "text-[#ec8000]",
    bg: "bg-[#ec80001a]",
  },
  [TIER.pro]: {
    text: "text-[#3389F0]",
    bg: "bg-[#006CEC1A]",
  },
  default: {
    text: "text-[#636369]",
    bg: "bg-[#F5F5F5]",
  },
};
